
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.367 1.4V0h-2.334v1.4H5.367V0H3.033v1.4H0V14h15.4V1.4h-3.033zM14 12.6H1.4V2.8H7v5.6h7v4.2zM14 7H8.4V2.8H14V7z","fill":"#2B3E8A"}})])
          )
        }
      }
    